import React from "react"
import styled from "styled-components"

export const Title = styled.h1`
    font-family: var(--font-1);
    color: var(--gray-text-1);
`;